import { useState, useEffect } from 'react';
import CardLike from './CardLike';

const VotingSection = ({ cardInfo }) => {
  const [currentTime, setCurrentTime] = useState(Math.floor(Date.now() / 1000));
  const [timeRemaining, setTimeRemaining] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    // Update current time every second
    const timer = setInterval(() => {
      setCurrentTime(Math.floor(Date.now() / 1000));
    }, 1000);

    // Calculate time until next state change
    if (cardInfo.contest_data) {
      let targetTime = null;
      
      if (currentTime < cardInfo.contest_data.voting_start) {
        // Time until voting starts
        targetTime = cardInfo.contest_data.voting_start;
      } else if (currentTime < cardInfo.contest_data.voting_end) {
        // Time until voting ends
        targetTime = cardInfo.contest_data.voting_end;
      }
      
      if (targetTime) {
        const secondsRemaining = targetTime - currentTime;
        if (secondsRemaining > 0) {
          const days = Math.floor(secondsRemaining / 86400);
          const hours = Math.floor((secondsRemaining % 86400) / 3600);
          const minutes = Math.floor((secondsRemaining % 3600) / 60);
          const seconds = secondsRemaining % 60;
          
          setTimeRemaining({ days, hours, minutes, seconds });
        }
      }
    }

    return () => clearInterval(timer);
  }, [currentTime, cardInfo.contest_data]);

  if (!cardInfo.contest_data || Number(cardInfo.approvedGallery) !== 5) {
    return null;
  }

  // Render a flip clock style digit
  const FlipDigit = ({ value, label }) => (
    <div className="d-inline-block text-center mx-1">
      <div className="position-relative">
        <div className="bg-dark text-white rounded p-2 shadow" style={{ minWidth: '40px' }}>
          <span className="fs-5 fw-bold">{value.toString().padStart(2, '0')}</span>
        </div>
        <div className="position-absolute w-100" style={{ top: '50%', left: 0 }}>
          <div className="border-top border-secondary opacity-25"></div>
        </div>
      </div>
      <div className="text-center mt-1">
      <small className="text-white">{label}</small>
      </div>
    </div>
  );

  return (
    <>
      {currentTime >= cardInfo.contest_data.voting_start && 
       currentTime <= cardInfo.contest_data.voting_end ? (
        <CardLike
          cardid={cardInfo.cardId}
          initialLiked={cardInfo.contest_data.is_liked}
          contestid={cardInfo.contest_data.contest_id}
        />
      ) : (
        <div className="my-3">
          {currentTime < cardInfo.contest_data.voting_start ? (
            <div className="text-center">
              <div className="mb-2 text-primary text-white fw-bold">Voting opens in</div>
              <div className="d-flex justify-content-center">
                {timeRemaining.days > 0 && (
                  <FlipDigit value={timeRemaining.days} label="Days" />
                )}
                <FlipDigit value={timeRemaining.hours} label="Hours" />
                <FlipDigit value={timeRemaining.minutes} label="Mins" />
                <FlipDigit value={timeRemaining.seconds} label="Secs" />
              </div>
            </div>
          ) : (
            <div className="alert alert-secondary text-center">
              <i className="bi bi-hourglass-bottom me-2"></i>
              Voting period has ended
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default VotingSection;